<template lang="pug">
   app-card
     app-card-header
       | {{ shortDate(advocatAppItem.eventDate)  }}  
       v-spacer
       | {{ advocatAppItem.appStatus.title }}
       .ellipse.ml-3(:style="'background:'+statusColor(advocatAppItem.appStatus)")
     app-card-body.document__card-body
       app-card-title.document__card-title {{ advocatAppItem.advocatEventType.title }}
       app-card-caption.mb-2 Коэффициенты: 
           span(v-for="(k, index) in advocatAppItem.boostingKfs" :key="index" ) {{ k.title }}

       app-card-caption.text-subtitle-1(v-if="advocatAppItem.startTariff!=advocatAppItem.tariff && advocatAppItem.startTariff!=0") 
           v-layout.justify-space-between
             span Тариф: 
             strong
               span {{ advocatAppItem.tariff }} руб. 
               del {{ advocatAppItem.startTariff }} руб.
       app-card-caption.text-subtitle-1(v-else) Тариф: 
             strong {{ advocatAppItem.tariff }} руб.
           
       app-card-caption(v-if="advocatAppItem.judgeComment")  
           hr.my-1 
           | комментарий судьи:
           br
           | <b>{{ advocatAppItem.judgeComment }}</b>

</template>

<script>
import moment from 'moment'
moment.locale('ru');
import AppStatuses from "@/assets/data/SpecAppStatuses.json"

export default {
  props: {
    advocatAppItem: null,
    fromAdvocat: {
        default:true,
        type:Boolean
    }
  },
  methods: {
    shortDate(date) {
      return moment(date).format("DD.MM.YYYY")
    },
    statusColor(status) {
      if (status.color > 0 && status.color < 4) {
        return AppStatuses.colors[status.color]
      }
      return '#000'
    },
    itemTitle(item) {
      return moment( item.eventDate ).format('DD-MM-YYYY')+" - "+item.advocatEventType.title
    }
  },
}
</script>

<style lang="scss" scoped>

.ellipse {
  width: 8px;
  height: 8px;
  border-radius: 4px;
  margin-left: 6px;
}

</style>
